import { Container } from '@components/ui'
import React from 'react'
import { ydBenefitsAssets } from './helpers'
import Slider from 'react-slick'
import cn from 'clsx'
import 'slick-carousel/slick/slick.css'
//import 'slick-carousel/slick/slick-theme.css'

const YdBenefits = ({
  className,
  isHome = true,
  isLabCreated = false,
}: {
  className?: string
  isHome: boolean
  isLabCreated?: boolean
}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    className: '!h-full !flex !flex-col !justify-between',
    dotsClass: cn({ button__bar: isHome }, { button__bar_inverse: !isHome }),
    appendDots: (dots: any) => (
      <div className="-bottom-5">
        <ul style={{ margin: '0px', zIndex: 0, display: 'flex' }}> {dots} </ul>
      </div>
    ),
  }

  const dataToMap = isLabCreated ? ydBenefitsAssets.slice(1) : ydBenefitsAssets

  return (
    <section
      className={cn(
        'flex flex-col items-center justify-evenly w-full h-full gap-4 min-h-[250px] md:h-[460px] md:justify-center md:gap-[2.65rem] pt-10 pb-[11px] md:pb-10',
        className
      )}
    >
      <Container className="flex flex-col items-center justify-center w-full gap-4 lg:gap-0 lg:mb-6">
        <div className="text-center">
          <h2
            className={cn(
              {
                'font-normal font-heading text-2.5xl md:pb-5 lg:text-3.5xl':
                  isHome,
              },
              {
                'font-normal font-heading text-2.5xl md:pb-5 text-white lg:text-3.5xl':
                  !isHome,
              }
            )}
          >
            YADAV's Benefits
          </h2>
        </div>
        <div className="w-3/4 text-center md:w-full flex items-center justify-center">
          <p
            className={cn(
              {
                'my-auto text-sm text-gray-dark md:text-base': isHome,
              },
              { 'my-auto text-sm text-white md:text-base': !isHome }
            )}
          >
            Our reputation for excellence includes.
          </p>
        </div>
      </Container>

      <Container className='text-center'>
        <div className="w-full h-48 overflow-hidden md:hidden">
          <Slider {...settings}>
            {dataToMap.map((item, index) => {
              return (
                <div
                  className="!flex !flex-col !items-center !justify-start !w-[17rem] !gap-2 my-4 !mx-auto"
                  key={index}
                >
                  <div className={cn({ 'text-white': !isHome })}>
                    {item.icon()}
                  </div>
                  <p
                    className={cn(
                      { 'text-sm font-bold': isHome },
                      { 'text-sm font-bold text-white': !isHome }
                    )}
                  >
                    {item.title}
                  </p>
                  <p
                    className={cn(
                      { 'text-sm text-gray-dark mb-4 md:mb-0': isHome },
                      { 'text-sm text-white mb-4 md:mb-0': !isHome }
                    )}
                  >
                    {item.text}
                  </p>
                </div>
              )
            })}
          </Slider>
        </div>
        <div className="hidden md:flex md:flex-row md:flex-wrap md:items-start md:gap-12 md:justify-around md:w-full xl:justify-center xl:gap-12">
          {dataToMap.map((item, index) => {
            return (
              <div
                className="flex flex-col items-center justify-center w-[17rem] gap-2"
                key={index}
              >
                <div className={cn({ 'text-white': !isHome })}>
                  {item.icon()}
                </div>
                <p
                  className={cn(
                    { 'text-base font-bold': isHome },
                    { 'text-base font-bold text-white': !isHome }
                  )}
                >
                  {item.title}
                </p>
                <p
                  className={cn(
                    { 'text-base text-gray-dark': isHome },
                    { 'text-base text-white': !isHome }
                  )}
                >
                  {item.text}
                </p>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}

export default YdBenefits
